<template>
    <ion-card class="floating floating-large">
        <ion-card-header>
            <ion-card-title>{{ $t('ncrypt.company') }}</ion-card-title>
        </ion-card-header>
        <ion-card-content>
            <ion-item>
                <ion-label slot="start">{{ $t('ncrypt.company_name') }}</ion-label>
                <ion-text>{{ company.name }}</ion-text>
            </ion-item>
            <ion-item v-for="(limit, name) in company.limits" :key="name" >
                <ion-label slot="start">
                    {{ limit.title }}
                    <ion-icon ref="attachmentInfo" ios='information-circle' md="information-circle" slot="end"></ion-icon>
                </ion-label>
                <ion-text>{{ limit.label }}</ion-text>
            </ion-item>
        </ion-card-content>
    </ion-card>
</template>

<script>
    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css';
    import 'tippy.js/dist/svg-arrow.css';
    import {roundArrow} from 'tippy.js';

    export default {
        name: "CompanyDetails",
        data() {
            return {
                company: this.$store.getters.company,
            }
        },
        methods: {},
        mounted() {
            this.$nextTick(async () => {
                tippy(this.$refs.attachmentInfo, {
                    content: this.$t('ncrypt.contact_need_more').replace('{contact}', `<a href="mailto:info@ncrypt.nl">${this.$t('ncrypt.contact')}</a>`),
                    placement: 'bottom',
                    arrow: roundArrow,
                    interactive: true,
                    appendTo: document.body,
                });
            });
        },
    }
</script>
